import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { NAV_ITEMS } from "@/constants/navItems";
import ContactDialog from "./ContactDialog";
import { motion } from "framer-motion";


const MobileNav = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleToggle = () => setOpen(prev => !prev);

  const scrollToSection = (hash: string) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/" + hash);
      return;
    }
    setTimeout(() => {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 300);
  };

  return (
    <div className="md:hidden flex items-center">
      <Button
        variant="ghost"
        size="icon"
        className="h-10 w-10 rounded-full hover:bg-white/60 relative z-[70]"
        aria-label="Toggle menu"
        onClick={handleToggle}
      >
        <motion.span
          className="flex flex-col items-center justify-center w-[18px] h-[18px] relative"
          animate={open ? "open" : "closed"}
          initial={false}
        >
          <motion.span
            className="absolute w-full h-[1.5px] bg-current rounded-full will-change-transform"
            variants={{
              closed: { y: -3.5, rotate: 0 },
              open: { y: 0, rotate: 45 },
            }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
          />
          <motion.span
            className="absolute w-full h-[1.5px] bg-current rounded-full will-change-transform"
            variants={{
              closed: { opacity: 1 },
              open: { opacity: 0 },
            }}
            transition={{ duration: 0.1 }}
          />
          <motion.span
            className="absolute w-full h-[1.5px] bg-current rounded-full will-change-transform"
            variants={{
              closed: { y: 3.5, rotate: 0 },
              open: { y: 0, rotate: -45 },
            }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
          />
        </motion.span>
      </Button>

      <Sheet open={open} onOpenChange={setOpen} modal={false}>
        <SheetContent
          side="top"
          showOverlay={false}
          onInteractOutside={(e) => e.preventDefault()}
          className="bg-background/95 backdrop-blur-xl border-border pt-20 pb-4 px-4 z-[55]"
        >
          <nav className="flex flex-col gap-0.5">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.path}
                onClick={() => scrollToSection(item.path)}
                className="px-4 py-2.5 text-sm font-medium text-left text-foreground/80 hover:text-foreground hover:bg-foreground/5 rounded-lg transition-colors"
              >
                {item.label}
              </button>
            ))}

            <div className="pt-2">
              <ContactDialog>
                <Button className="w-full bg-primary hover:bg-primary-hover text-primary-foreground font-semibold rounded-full text-sm py-5">
                  Let's Talk
                </Button>
              </ContactDialog>
            </div>
          </nav>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default MobileNav;
